
export enum ESortOrder {
	/** Tri croissant (alphabétique, plus vieux au plus récent). */
	ascending = "asc",
	/** Tri décroissant (alphabétique inversé, plus récent au plus vieux). */
	descending = "desc"
}